import { z } from 'zod';
const cuid = z.string().cuid();
export const giftKindSchema = z.enum(['standard', 'collectible']);
export const giftCatalogQuerySchema = z
    .object({ kind: z.enum(['all', 'standard', 'collectible']).default('all') })
    .strict();
export const giftSendSchema = z
    .object({
    recipientId: cuid,
    catalogItemId: cuid,
    note: z.string().trim().max(280).optional(),
    anonymous: z.boolean().default(false),
    clientId: z.string().trim().min(8).max(128)
})
    .strict();
export const giftVisibilitySchema = z.object({ profileVisible: z.boolean() }).strict();
export const giftRegiftSchema = z
    .object({
    recipientId: cuid,
    note: z.string().trim().max(280).optional(),
    anonymous: z.boolean().default(false),
    clientId: z.string().trim().min(8).max(128)
})
    .strict();
export const starPackSchema = z.enum(['100', '500', '1000', '2500', '5000']);
export const starCheckoutSchema = z
    .object({ pack: starPackSchema, clientId: z.string().trim().min(8).max(128) })
    .strict();
export const premiumGiftMonthsSchema = z.union([z.literal(3), z.literal(6), z.literal(12)]);
export const premiumGiftCheckoutSchema = z
    .object({
    recipientId: cuid,
    months: premiumGiftMonthsSchema,
    // sbp — деньгами через кассу (RollyPay, СБП); lava — то же от старых клиентов.
    paymentMethod: z.enum(['stars', 'sbp', 'lava']),
    clientId: z.string().trim().min(8).max(128)
})
    .strict();
/**
 * Новый подарок в каталоге.
 *
 * Заводится черновиком и публикуется отдельным действием: недоделанный подарок
 * не должен попасть людям раньше, чем автор посмотрит на него глазами.
 * Тираж обязателен у коллекционных и запрещён у обычных — «ограниченный
 * выпуск» без числа не ограничен ничем.
 */
export const adminGiftCatalogCreateSchema = z
    .object({
    title: z.string().trim().min(1).max(80),
    imageUrl: z.string().trim().min(1).max(500),
    kind: giftKindSchema,
    priceStars: z.number().int().min(1).max(10_000_000),
    position: z.number().int().min(0).max(100_000).default(0),
    supply: z.number().int().min(1).max(10_000_000).nullable().default(null)
})
    .strict()
    .refine((value) => (value.kind === 'collectible' ? value.supply !== null : value.supply === null), {
    path: ['supply'],
    message: 'Тираж указывается только у коллекционных подарков'
});
export const adminGiftCatalogUpdateSchema = z
    .object({
    title: z.string().trim().min(1).max(80).optional(),
    imageUrl: z.string().trim().min(1).max(500).optional(),
    priceStars: z.number().int().min(1).max(10_000_000).optional(),
    position: z.number().int().min(0).max(100_000).optional(),
    status: z.enum(['draft', 'active', 'archived']).optional(),
    supply: z.number().int().min(1).max(10_000_000).nullable().optional()
})
    .strict()
    .refine((value) => Object.keys(value).length > 0);
export const adminGiftSettingsSchema = z
    .object({
    starPacks: z
        .array(z
        .object({
        code: starPackSchema,
        stars: z.number().int().min(1),
        amountKopecks: z.number().int().min(100)
    })
        .strict())
        .length(5),
    premiumPlans: z
        .array(z
        .object({
        months: premiumGiftMonthsSchema,
        priceStars: z.number().int().min(1),
        amountKopecks: z.number().int().min(100)
    })
        .strict())
        .length(3),
    /* Награда за пришедшего по ссылке-приглашению. Ноль выключает её вовсе. */
    referralBonusStars: z.number().int().min(0).max(1_000_000),
    /* Сколько стоит сменить логин. Ноль сделал бы смену бесплатной. */
    loginChangeStars: z.number().int().min(1).max(1_000_000)
})
    .strict();
export const adminGiftBalanceAdjustSchema = z
    .object({
    userId: cuid,
    amount: z.number().int().min(-10_000_000).max(10_000_000).refine(Boolean),
    reason: z.string().trim().min(3).max(280),
    clientId: z.string().trim().min(8).max(128)
})
    .strict();
//# sourceMappingURL=gifts.js.map